import React, { useEffect, useState } from 'react';
import MailchimpSubscribe from "react-mailchimp-subscribe"
import './style.css';

const initialContactUs = {
    EMAIL: '',
    FNAME: '',
    LNAME: '',
    MMERGE11: '', // How Can We Help
};
const initialCCPA = {
    EMAIL: '',
    FNAME: '',
    LNAME: '',
    MMERGE11: '', // Street Address
    MMERGE7: '',  // City
    MMERGE9: '',  // State
    MMERGE10: '', // Zip
    CA_REQUEST: '',
};
const initialDoNotSell = {
    EMAIL: '',
    FNAME: '',
    LNAME: '',
    MMERGE11: '', // Street Address
    MMERGE7: '',  // City
    MMERGE9: '',  // State
    MMERGE10: '', // Zip
    CA_DN_SELL: '', // Do Not Sell
    MMERGE17: '', // Optional Message
};

const ContactUsForm = ({ type = "contact-us" }) => {
    const [formValues, setFormValues] = useState(
        type === 'ccpa-data-request' ? initialCCPA :
        type === 'do-not-sell' ? initialDoNotSell :
        initialContactUs
    );
    const [status, setStatus] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const contactUsFormUrl = "https://quollintelligence.us6.list-manage.com/subscribe/post?u=deab1f50d72e82ec800eea2bb&amp;id=ba686093b1&amp;f_id=0097d2e5f0";
    const ccpaDataRequestFormUrl = "https://getquoll.us6.list-manage.com/subscribe/post?u=deab1f50d72e82ec800eea2bb&id=f5ef8e3ed6&f_id=000337e3f0"

    let formAction = contactUsFormUrl;
    if (type === "ccpa-data-request") {
        formAction = ccpaDataRequestFormUrl;
    }
    // console.log(formAction)

    useEffect(() => {
        // Check if CSS is already loaded
        const existingLink = document.querySelector('link[href*="mailchimp"]');
        if (!existingLink) {
            const link = document.createElement('link');
            link.href = '//cdn-images.mailchimp.com/embedcode/classic-061523.css';
            link.rel = 'stylesheet';
            link.type = 'text/css';
            document.head.appendChild(link);
        }

        // Check if script is already loaded
        const existingScript = document.querySelector('script[src*="mc-validate"]');
        if (!existingScript) {
            const script = document.createElement('script');
            script.src = '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js';
            script.async = true;
            document.head.appendChild(script);

            script.onload = () => {
                // Initialize validation
                if (window.jQuery) {
                    window.fnames = new Array();
                    window.ftypes = new Array();
                    window.fnames[0] = 'EMAIL'; window.ftypes[0] = 'email';
                    window.fnames[1] = 'FNAME'; window.ftypes[1] = 'text';
                    window.fnames[2] = 'LNAME'; window.ftypes[2] = 'text';
                    window.fnames[3] = 'ADDRESS'; window.ftypes[3] = 'address';
                    window.fnames[4] = 'PHONE'; window.ftypes[4] = 'phone';
                    window.fnames[5] = 'CA_REQUEST'; window.ftypes[5] = 'text';
                    window.fnames[6] = 'CA_DN_SELL'; window.ftypes[6] = 'text';
                    window.fnames[7] = 'MMERGE7'; window.ftypes[7] = 'text';
                    window.fnames[8] = 'PERS_DATA'; window.ftypes[8] = 'text';
                    window.fnames[9] = 'MMERGE9'; window.ftypes[9] = 'text';
                    window.fnames[10] = 'MMERGE10'; window.ftypes[10] = 'zip';
                    window.fnames[11] = 'MMERGE11'; window.ftypes[11] = 'text';
                    window.fnames[12] = 'DATA_DEL'; window.ftypes[12] = 'text';
                    window.fnames[13] = 'MMERGE13'; window.ftypes[13] = 'text';
                    window.fnames[14] = 'MMERGE14'; window.ftypes[14] = 'text';
                    window.fnames[15] = 'MMERGE15'; window.ftypes[15] = 'text';
                    window.fnames[16] = 'MMERGE16'; window.ftypes[16] = 'text';
                    window.fnames[17] = 'MMERGE17'; window.ftypes[17] = 'text';
                    window.fnames[18] = 'MMERGE18'; window.ftypes[18] = 'text';
                }
            };
        }
    }, []); // Empty dependency array means this runs once on mount

    const mailChimpUrl = "https://getquoll.us6.list-manage.com/subscribe/post-json?u=deab1f50d72e82ec800eea2bb&amp;id=f5ef8e3ed6&amp;f_id=000337e3f0&c=?"

    const emailTitle = "Email Address"
    const firstNameTitle = "First Name"
    const lastNameTitle = "Last Name"
    const howCanWeHelpTitle = "How Can We Help"
    const submitButtonText = submitting ? "Submitting..." : "Submit"
    const requiredText = "Required"

    const handleChange = (e) => {
        setFormValues({ ...formValues, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitting(true);
        setStatus(null);

        // Build params
        const params = new URLSearchParams();
        Object.entries(formValues).forEach(([key, value]) => {
            params.append(key, value);
        });
        // Add hidden tags
        if (type === 'ccpa-data-request') {
            params.append('tags', '3259573,3389868');
        } else if (type === 'do-not-sell') {
            params.append('tags', '3389908,3389868,3260005');
        } else {
            params.append('tags', '3389904');
        }
        params.append('c', 'callback');

        // Mailchimp endpoint
        const url = (
            type === 'ccpa-data-request'
                ? 'https://getquoll.us6.list-manage.com/subscribe/post-json?u=deab1f50d72e82ec800eea2bb&id=f5ef8e3ed6&f_id=000337e3f0'
                : type === 'do-not-sell'
                ? 'https://getquoll.us6.list-manage.com/subscribe/post-json?u=deab1f50d72e82ec800eea2bb&id=f5ef8e3ed6&f_id=0098d2e5f0'
                : 'https://quollintelligence.us6.list-manage.com/subscribe/post-json?u=deab1f50d72e82ec800eea2bb&id=ba686093b1&f_id=0097d2e5f0'
        ) + '&' + params.toString();

        // JSONP: create a script tag
        window.callback = (data) => {
            setSubmitting(false);
            if (data.result === 'success') {
                setStatus('success');
                setFormValues(
                    type === 'ccpa-data-request' ? initialCCPA :
                    type === 'do-not-sell' ? initialDoNotSell :
                    initialContactUs
                );
            } else {
                setStatus('error');
            }
        };
        const script = document.createElement('script');
        script.src = url;
        document.body.appendChild(script);
        script.onload = () => {
            document.body.removeChild(script);
        };
    };

    useEffect(() => {
        if (status === 'success') {
            setTimeout(() => {
                setStatus(null);
            }, 3000);
        }
    }, [status]);

    return (
        <>
            {status !== 'success' && (
                <div id="mc_embed_shell" className="contact-us-form-container">
                    <div id="mc_embed_signup">
                        <form
                            onSubmit={handleSubmit}
                            id="mc-embedded-subscribe-form"
                            name="mc-embedded-subscribe-form" 
                            className="validate"
                            autoComplete="off"
                        >
                            <div id="mc_embed_signup_scroll" className="contact-us-form-content">

                                <div className="indicates-required">
                                    <span className="asterisk">*</span> {requiredText}
                                </div>

                                {/* Shared fields */}
                                <div className="mc-field-group">
                                    <label htmlFor="mce-EMAIL">
                                        {emailTitle} <span className="asterisk">*</span>
                                    </label>
                                    <input
                                        type="email"
                                        name="EMAIL"
                                        className="required email"
                                        id="mce-EMAIL"
                                        required
                                        value={formValues.EMAIL}
                                        onChange={handleChange}
                                        disabled={submitting}
                                    />
                                </div>
                                <div className="mc-field-group">
                                    <label htmlFor="mce-FNAME">
                                        {firstNameTitle} <span className="asterisk">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="FNAME"
                                        className="required text"
                                        id="mce-FNAME"
                                        required
                                        value={formValues.FNAME}
                                        onChange={handleChange}
                                        disabled={submitting}
                                    />
                                </div>
                                <div className="mc-field-group">
                                    <label htmlFor="mce-LNAME">
                                        {lastNameTitle} <span className="asterisk">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="LNAME"
                                        className="required text"
                                        id="mce-LNAME"
                                        required
                                        value={formValues.LNAME}
                                        onChange={handleChange}
                                        disabled={submitting}
                                    />
                                </div>

                                {/* Conditional address fields for ccpa-data-request and do-not-sell */}
                                {(type === 'ccpa-data-request' || type === 'do-not-sell') && (
                                    <>
                                        <div className="mc-field-group">
                                            <label htmlFor="mce-MMERGE11">Street Address <span className="asterisk">*</span></label>
                                            <input type="text" name="MMERGE11" className="required text" id="mce-MMERGE11" required value={formValues.MMERGE11} onChange={handleChange} disabled={submitting} />
                                        </div>
                                        <div className="mc-field-group">
                                            <label htmlFor="mce-MMERGE7">City <span className="asterisk">*</span></label>
                                            <input type="text" name="MMERGE7" className="required text" id="mce-MMERGE7" required value={formValues.MMERGE7} onChange={handleChange} disabled={submitting} />
                                        </div>
                                        <div className="mc-field-group">
                                            <label htmlFor="mce-MMERGE9">State <span className="asterisk">*</span></label>
                                            <input type="text" name="MMERGE9" className="required text" id="mce-MMERGE9" required value={formValues.MMERGE9} onChange={handleChange} disabled={submitting} />
                                        </div>
                                        <div className="mc-field-group">
                                            <label htmlFor="mce-MMERGE10">Zip <span className="asterisk">*</span></label>
                                            <input type="text" name="MMERGE10" className="required zip" id="mce-MMERGE10" required value={formValues.MMERGE10} onChange={handleChange} disabled={submitting} />
                                        </div>
                                    </>
                                )}
                                {/* Unique fields for ccpa-data-request */}
                                {type === 'ccpa-data-request' && (
                                    <div className="mc-field-group">
                                        <label htmlFor="mce-CA_REQUEST">Validate My Request <span className="asterisk">*</span></label>
                                        <input type="text" name="CA_REQUEST" className="required text" id="mce-CA_REQUEST" required value={formValues.CA_REQUEST} onChange={handleChange} disabled={submitting} />
                                        <span id="mce-CA_REQUEST-HELPERTEXT" className="helper_text">Indicate if you want your data deleted/learn how it's used</span>
                                    </div>
                                )}
                                {/* Unique fields for do-not-sell */}
                                {type === 'do-not-sell' && (
                                    <>
                                        <div className="mc-field-group">
                                            <label htmlFor="mce-CA_DN_SELL">Do Not Sell <span className="asterisk">*</span></label>
                                            <input type="text" name="CA_DN_SELL" className="required text" id="mce-CA_DN_SELL" required value={formValues.CA_DN_SELL} onChange={handleChange} disabled={submitting} />
                                            <span id="mce-CA_DN_SELL-HELPERTEXT" className="helper_text">Let us know if you'd like to "opt out"</span>
                                        </div>
                                        <div className="mc-field-group">
                                            <label htmlFor="mce-MMERGE17">Optional Message </label>
                                            <input type="text" name="MMERGE17" className="text" id="mce-MMERGE17" value={formValues.MMERGE17} onChange={handleChange} disabled={submitting} />
                                        </div>
                                    </>
                                )}

                                {/* Conditional field for contact-us */}
                                {type !== 'ccpa-data-request' && type !== 'do-not-sell' && (
                                    <>
                                        <div className="mc-field-group">
                                            <label htmlFor="mce-MMERGE11">
                                                {howCanWeHelpTitle} <span className="asterisk">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="MMERGE11"
                                                className="required text"
                                                id="mce-MMERGE11"
                                                required
                                                value={formValues.MMERGE11}
                                                onChange={handleChange}
                                                disabled={submitting}
                                            />
                                        </div>
                                    </>
                                )}

                                <div id="mce-responses" className="clear">
                                    <div className="response" id="mce-error-response" style={{ display: 'none' }}></div>
                                    <div className="response" id="mce-success-response" style={{ display: 'none' }}></div>
                                </div>

                                <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
                                    <input
                                        type="text"
                                        name={type === 'ccpa-data-request' ? "b_deab1f50d72e82ec800eea2bb_f5ef8e3ed6" : type === 'do-not-sell' ? "b_deab1f50d72e82ec800eea2bb_f5ef8e3ed6" : "b_deab1f50d72e82ec800eea2bb_ba686093b1"}
                                        tabIndex="-1"
                                    />
                                </div>

                                <div className={type === 'ccpa-data-request' || type === 'do-not-sell' ? 'clear' : 'contact-us-form-submit-button-container'}>
                                    <input
                                        type="submit"
                                        name="subscribe"
                                        id="mc-embedded-subscribe"
                                        className="contact-us-form-submit-button"
                                        value={submitButtonText}
                                        disabled={submitting}
                                    />
                                </div>
                            </div>
                            {status === 'error' && <div className="contact-us-form-error">There was an error. Please check your info and try again.</div>}
                        </form>
                    </div>
                </div>
            )}
            {status === 'success' && <div className="contact-us-form-success">Submitted successfully!</div>}
        </>
    );
};

export default ContactUsForm;